import React from 'react';
import PropTypes from 'prop-types';

import FaqSection from './FaqSection';

import AbsoluteAsset from '../AbsoluteAsset';
import AbsoluteGear from '../AbsoluteGear';

import './faqs.scss';

const Faqs = ({ data }) => (
  <div className="container abs-asset-holder faqs-container">
    <div id="FAQ" />
    <h1 className="faqs-title">{data.title}</h1>
    <div className="faqs">
      <FaqSection data={data.faq_about} title="About" />
      <FaqSection data={data.faq_hacking} title="Hacking" />
    </div>
    <AbsoluteGear className="gear--yellow" speed={-10} src="/images/yellow1.png" />
    <AbsoluteGear className="gear--red" speed={-10} src="/images/red2.png" />
    <AbsoluteGear className="gear--blue" src="/images/blue1.png" />
    <AbsoluteGear className="gear--green" src="/images/green1.png" />
    <AbsoluteAsset className="trees--left" src="/images/trees_left.png" />
    <AbsoluteAsset className="trees--right" src="/images/trees_right.png" />
    <AbsoluteAsset className="goose" src="/images/goose.png" />
    <AbsoluteAsset className="square square--left" src="/images/square.png" />
    <AbsoluteAsset className="square square--right" src="/images/square.png" />
  </div>
);

Faqs.propTypes = {
  data: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default Faqs;



// WEBPACK FOOTER //
// ./src/components/Faqs/index.jsx